import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

import { Typography } from "@mui/material";
import { LogoutContainerContainer, LogoutStyledCard } from '../../Styles/Authentication/authenticationStyles';

import { RouteEnum } from '../../Utilities/Enums/RouteEnums';
import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';

import { AssetImages } from "../../Constants/Assets";
import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import AuthFooter from './AuthFooter';

export default function SignUp() {
    const navigate = useNavigate();

    //Use States

    //Variables
    
    //Event Handlers

    //Rendering Functions
    return <LogoutContainerContainer className='glossy-box'>
        <div className="logoutBgContainer">
            <LogoutStyledCard elevation={3}>
                <div className="logoutContainer">
                    <div className="logoutContents">
                        <img src={AssetImages.WEB_APP_LOGO} />
                        <Typography color="primaryText" className="headerText">You are Logged Out</Typography>
                        <Typography className="thankyouText">Thank you for using {StaticDisplayText.APP_NAME}</Typography>

                        <CustomButton
                            btnType={ButtonType.PRIMARY}
                            title='Sign In'
                            className="signInBtn"
                            onClick={(e: any) => {
                                navigate(RouteEnum.LOGIN, { replace: true });
                            }} />
                    </div>

                    <div className="spacer2" />
                    
                    <AuthFooter />
                </div>
            </LogoutStyledCard>
        </div>
    </LogoutContainerContainer>
}